import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Drop-in replacement for the abandoned `react-s-alert` package, removed during the
// React 19 upgrade (it peer-locked to React 15/16). The app calls
// Alert.success/error/warning/info(message, options?) in ~23 places and mounts a single
// <Alert/> container in src/index.js; here we back the same API with react-toastify and
// re-export a ToastContainer to mount instead.

// Map the few react-s-alert positions used in the codebase to react-toastify equivalents.
const POSITION_MAP = {
  top: "top-center",
  "top-left": "top-left",
  "top-right": "top-right",
  bottom: "bottom-center",
  "bottom-left": "bottom-left",
  "bottom-right": "bottom-right",
};

const normalize = opts => {
  if (!opts) return undefined;
  const out = {};
  if (typeof opts.timeout === "number") out.autoClose = opts.timeout;
  if (opts.position && POSITION_MAP[opts.position]) out.position = POSITION_MAP[opts.position];
  return out;
};

const Alert = {
  success: (msg, opts) => toast.success(msg, normalize(opts)),
  error: (msg, opts) => toast.error(msg, normalize(opts)),
  warning: (msg, opts) => toast.warn(msg, normalize(opts)),
  info: (msg, opts) => toast.info(msg, normalize(opts)),
  // react-s-alert exposed close(id) / closeAll(); toast.dismiss() closes all when id is absent.
  close: id => (id != null ? toast.dismiss(id) : toast.dismiss()),
  closeAll: () => toast.dismiss(),
};

export { ToastContainer };
export default Alert;
